import axios from "axios";
import { getHostName } from "api-helpers/getHostName.ts";

// Tell Axios to automatically include the CSRF token from the cookie
axios.defaults.xsrfCookieName = "csrftoken"; // Default Django cookie name
axios.defaults.xsrfHeaderName = "X-CSRFToken"; // Default Django header name

// Also ensure credentials (cookies) are sent
axios.defaults.withCredentials = true;

export const logoutApp = async (accessToken: string) => {
  // Note: Logout analytics recording has been removed

  // Call the regular logout endpoint
  return axios
    .post(
      `${getHostName()}/api/v1/logout/`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error logging out", error);
    });
};
